import debounce from 'lodash.debounce';
import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import Search from '../../components/shared/search/Search';
import { setVehiclesSearchAction } from '../../redux/actions/vehiclesActions';
import CreateVehicleModal from '../vehicle/modals/CreateVehicleModal';

const VehiclesHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.vehicles?.search);
  const [showCreateVehicleModal, setShowCreateVehicleModal] = useState(false);

  const debounced = debounce((args) => {
    dispatch(setVehiclesSearchAction(args));
  }, 500);

  const handleSearchChange = (newSearchValue) => {
    debounced(newSearchValue);
  };

  return (
    <ContainerHeader>
      {showCreateVehicleModal && <CreateVehicleModal onModalClose={() => setShowCreateVehicleModal(false)} />}
      <Search value={search.search} onChangeAction={handleSearchChange} />
      {!readOnly && (
        <Button variant={'primary'} onClick={() => setShowCreateVehicleModal(true)}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default VehiclesHeader;
